import CryptoJS from "crypto-js";

// 盒子v4接口、分包接口签名处理
function sortEncodeAndHash(objData, key) {
  // 获取对象的键并排序
  const sortedKeys = Object.keys(objData).sort();
  // 使用排序后的键生成一个新的对象
  const sortedObj = {};
  sortedKeys.forEach((key) => {
    sortedObj[key] = objData[key];
  });

  let sign = `991701${JSON.stringify(sortedObj)}${key ? key : "4C5CBC70C5FF6742D133D93D730D4C96"
    }`;

  // console.log("签名信息---", sign);

  // Base64 编码
  const base64Encoded = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(sign)
  );
  // console.log("base64编码后的信息---", base64Encoded);

  // MD5 加密
  const md5Hash = CryptoJS.MD5(base64Encoded).toString(CryptoJS.enc.Hex);
  // console.log("md5加密后的信息---", md5Hash);

  return md5Hash;
}

export { sortEncodeAndHash };
